module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.2ef5876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/fullscreen-image_hero_768.png
// module id = 6ukc
// module chunks = 0